import Component from '../abstracts/Component';

export default class DataShowComponent extends Component {

  render() {
    super.render();

    let closed = true;
    let _this = this;

    $('*[data-show]').not('[data-show=""]').off('click deselect').on('click deselect', function (e) {

      // This will prevent double events
      if ($(e.target).is("label")) {
        return true;
      }

      let
        self = $(this),
        tSelector = self.data('show'),
        hSelector = self.data('hide'),
        cssClass = self.data('toggleClass') || 'in',
        selfClass = self.data('selfClass') || 'active',
        closest = self.data('parent'),
        slide = self.data('slide'),
        context = self.data('context'),
        selfText = self.data('selfText'),
        selfAlternativeText = self.data('selfAlternativeText'),
        state = self.data('state'),
        parent = closest ? self.closest(closest) : self,
        target = closest && (tSelector.match('^#') == null) ? parent.find(tSelector) : $(tSelector),
        hide = hSelector ? (closest && (hSelector.match('^#') == null) ? parent.find(hSelector) : $(hSelector)) : false,
        remoteUrl = target.data('remote'),
        switchControl = parent.find('input[type="radio"], input[type="checkbox"]'),
        showCondition = self.data('show-condition');


      if (showCondition && !showCondition.includes(Utils.Responsive.currentResolution.label)) {
        return;
      }

      slide = typeof slide != 'undefined' ? slide : true;

      if (context) {
        if (target.length == 0) {
          target = $(context).find(tSelector);
        }

        if (hide.length == 0) {
          hide = $(context).find(hSelector);
        }
      }

      if (selfAlternativeText && selfText) {
        _this.log(`Alternative text ${parentText}`);

        let parentText = state === 'closed' ? selfAlternativeText : selfText;

        parent.text(parentText);
        // closed = !closed;
        self.data('state', state === 'closed' ? 'opened' : 'closed');
      }

      if (switchControl.length != 0 && !switchControl.is(':disabled')) {

        if (switchControl.is(':checked')) {
          _this.log(`Switching off ${cssClass} on ${target}`);
          target.removeClass(cssClass);

        } else {
          _this.log(`Switching on ${cssClass} on ${target}`);
          target.addClass(cssClass);

        }

      } else {


        if (slide) {
          _this.log(`Toggling slide on ${target}`);
          target.slideToggle();
        } else {
          if (selfClass) {
            _this.log(`Toggling '${cssClass}' on target: ${target}`);
            target.toggleClass(cssClass);
            _this.log(`Toggling '${cssClass}' on parent: ${parent}`);
            parent.toggleClass(selfClass);
          } else {
            _this.log(`Toggling '${cssClass}' on parent: ${parent}`);
            parent.toggleClass(cssClass);
          }
        }

        if (remoteUrl && (target.is(':empty') || target.find('> .loading').length != 0)) {
          $.get(remoteUrl, function (body, status, xhr) {
            target.empty().append(body);
          });
        }

        $('body').trigger("formInitializeAll");

      }

      if (hide) {
        _this.log(`Hiding ${hide}`);
        hide.addClass('hidden');
      }

    });
  }

}
